import "./Home.module.css";
import Navbar from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Services from "./sections/Services";
import Fleet from "./sections/Fleet";
import Applications from "./sections/Applications";
import Coverage from "./sections/Coverage";
import Action from "./sections/Action";
import Organization from "./sections/Organization";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navbar />
      <Hero />
      <Services />
      <Fleet />
      <Applications />
      <Coverage />
      <Action />
      <Organization />
      <Footer />
    </div>;
}